// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2i5oa","title":"InfoRow_title__32Bts"};